// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M23.5 6c-.52 0-1.032.115-1.5.339V5.5a3.5 3.5 0 0 0-6.831-1.075A3.5 3.5 0 0 0 10 7.5v8l-.478-.766a3.5 3.5 0 0 0-6.075 3.477c2 4.222 3.617 7.215 5.465 9.087C10.78 29.192 12.9 30 16 30a11.013 11.013 0 0 0 11-11V9.5A3.5 3.5 0 0 0 23.5 6ZM25 19a9.01 9.01 0 0 1-9 9c-2.547 0-4.189-.61-5.666-2.106-1.654-1.676-3.177-4.519-5.097-8.571a.794.794 0 0 0-.037-.073 1.5 1.5 0 1 1 2.616-1.471l2.334 3.75A1 1 0 0 0 12 19V7.5a1.5 1.5 0 1 1 3 0V15a1 1 0 1 0 2 0V5.5a1.5 1.5 0 1 1 3 0V15a1 1 0 1 0 2 0V9.5a1.5 1.5 0 1 1 3 0V19Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
